var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPapers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49992 3.70833C6.31379 3.70833 4.54159 5.48054 4.54159 7.66667V12.5C4.54159 13.0753 4.07522 13.5417 3.49992 13.5417C2.92462 13.5417 2.45825 13.0753 2.45825 12.5V7.66667C2.45825 4.32995 5.1632 1.625 8.49992 1.625H12.5C13.0753 1.625 13.5416 2.09137 13.5416 2.66667C13.5416 3.24196 13.0753 3.70833 12.5 3.70833H8.49992Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 4.79171C7.21062 4.79171 5.62496 6.37737 5.62496 8.33337V15C5.62496 16.956 7.21062 18.5417 9.16663 18.5417H14.1666C16.1226 18.5417 17.7083 16.956 17.7083 15V8.33337C17.7083 6.37737 16.1226 4.79171 14.1666 4.79171H9.16663Z",
    fill: "inherit"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapers);
export default __webpack_public_path__ + "static/media/papers.88f99218.svg";
export { ForwardRef as ReactComponent };